<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="activityLogIsEmpty">Activity log is empty.</div>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <ActivityLog
      :activityLog="activityLog"
      v-if="activityLogLoaded"/>
  </div>
</template>

<script>
import Spinner from '@/components/utils/Spinner'
import ActivityLog from '@/components/utils/ActivityLog'

import {
  LOAD_ACTIVITY_LOG,
  IS_LOADING_ACTIVITY_LOG,
  GET_ACTIVITY_LOG,
  HAS_EMPTY_ACTIVITY_LOG_LOAD_RESULT,
  GET_ACTIVITY_LOG_LOAD_ERROR
} from './userStore'

export default {
  name: 'UserActivityLogTab',

  components: {
    ActivityLog,
    Spinner
  },

  props: {
    userStorePath: {
      type: String,
      required: true
    }
  },

  mounted() {
    const loadActivityLogAction = `${this.userStorePath}/${LOAD_ACTIVITY_LOG}`;
    this.$store.dispatch(loadActivityLogAction);
  },

  computed: {
    activityLogLoaded() {
      return this.activityLog !== null;
    },

    isLoading() {
      const isLoadingActivityLog = `${this.userStorePath}/${IS_LOADING_ACTIVITY_LOG}`;
      return this.$store.getters[isLoadingActivityLog];
    },

    activityLogIsEmpty() {
      const hasEmptyActivityLogLoadResult = `${this.userStorePath}/${HAS_EMPTY_ACTIVITY_LOG_LOAD_RESULT}`;
      return this.$store.getters[hasEmptyActivityLogLoadResult];
    },

    activityLog() {
      const getActivityLog = `${this.userStorePath}/${GET_ACTIVITY_LOG}`;
      return this.$store.getters[getActivityLog];
    },

    loadError() {
      const getActivityLogLoadError = `${this.userStorePath}/${GET_ACTIVITY_LOG_LOAD_ERROR}`;
      return this.$store.getters[getActivityLogLoadError];
    }
  }
};
</script>
